// extracted by mini-css-extract-plugin
export default {"bold":"faq_bold__gU+Bq"};